import React, { Component, PropTypes } from 'react';
import { prefixLink } from 'gatsby-helpers';

import Fullscreen from 'components/fullscreen';
import Wrapper from 'components/wrapper';
import { IndexLink, Link } from 'react-router';

import styles from './styles.module.css';
import Particles from 'react-particles-js';

const PARTICLES = {
  "particles": {
    "number": {
      "value": 30,
      "density": {
        "enable": false,
        "value_area": 800
      }
    },
    "color": {
      "value": "#ffffff"
    },
    "shape": {
      "type": "circle",
      "stroke": {
        "width": 0,
        "color": "#000000"
      },
      "polygon": {
        "nb_sides": 5
      },
      "image": {
        "src": "img/github.svg",
        "width": 100,
        "height": 100
      }
    },
    "opacity": {
      "value": 0.5,
      "random": false,
      "anim": {
        "enable": false,
        "speed": 1,
        "opacity_min": 0.1,
        "sync": false
      }
    },
    "size": {
      "value": 10,
      "random": true,
      "anim": {
        "enable": false,
        "speed": 80,
        "size_min": 0.1,
        "sync": false
      }
    },
    "line_linked": {
      "enable": true,
      "distance": 300,
      "color": "#ffffff",
      "opacity": 0.4,
      "width": 2
    },
    "move": {
      "enable": true,
      "speed": 2,
      "direction": "top",
      "random": true,
      "straight": false,
      "out_mode": "out",
      "bounce": false,
      "attract": {
        "enable": true,
        "rotateX": 600,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      "onhover": {
        "enable": true,
        "mode": "repulse"
      },
      "onclick": {
        "enable": false,
        "mode": "push"
      },
      "resize": true
    },
    "modes": {
      "grab": {
        "distance": 800,
        "line_linked": {
          "opacity": 1
        }
      },
      "bubble": {
        "distance": 800,
        "size": 80,
        "duration": 2,
        "opacity": 0.8,
        "speed": 3
      },
      "repulse": {
        "distance": 300,
        "duration": 0.6
      },
      "push": {
        "particles_nb": 4
      },
      "remove": {
        "particles_nb": 2
      }
    }
  },
  "retina_detect": true
}
export default class Menu extends Component {
  static propTypes = {
    active: PropTypes.bool,
    onNavClick: PropTypes.func,
  };

  render() {
    const linkProps = {
      onClick: this.props.onNavClick,
      activeClassName: styles.active,
    };
/*
<li className={styles.item}>
  <IndexLink {...linkProps} to={prefixLink('/')}>Layouceferie ?</IndexLink>
</li>
*/
    return (
      <Fullscreen className={this.props.active ? styles.menu : styles.disable}>
        <div className={styles.particlesStyle}>
          <Particles params={PARTICLES}/>
          </div>
        <Wrapper className={styles.inTheParticles}>
          <nav>
            <ul>
              <li className={styles.item}>
                <Link {...linkProps} to={prefixLink('/work/')}>Application</Link>
              </li>
              <li className={styles.item}>
                <Link {...linkProps} to={prefixLink('/about/')}>Résumé</Link>
              </li>
              <li className={styles.item}>
                <Link {...linkProps} to={prefixLink('/contact/')}>Contact</Link>
              </li>
            </ul>
          </nav>
        </Wrapper>
      </Fullscreen>
    );
  }
}



// WEBPACK FOOTER //
// ../components/menu/index.jsx